import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import githubImg from '../../images/github-contributions.png'

const StyledGithubSection = styled.section`
  max-width: 900px;

  .github-box {
    margin-top: 30px;
    text-align: center;
    background: var(--light-navy);
    padding: 30px;
    border-radius: var(--border-radius);
  }

  img {
    margin-top: 20px;
    max-width: 100%;
    border-radius: var(--border-radius);
  }
`;

const GithubActivity = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) return;
    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledGithubSection id="github" ref={revealContainer}>
      <h2 className="numbered-heading">GitHub Activity</h2>

      <p>
        Consistent development activity across personal and professional
        projects. Many contributions are within private repositories.
      </p>

      <div className="github-box">
        <img
            src={githubImg}
          alt="GitHub Contributions"
        />
      </div>
    </StyledGithubSection>
  );
};

export default GithubActivity;